module.exports = __webpack_public_path__ + "static/media/Pappa Di Gaddi 2.927ee1a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Pappa Di Gaddi 2.jpg
// module id = 139
// module chunks = 0